export const PUBLIC_PATHS = {
  LOGIN: "/login",
  SIGNUP: "/signup",
};

export const PRIVATE_PATHS = {
  DASHBOARD: "/dashboard",
  PAYMENT: "/payments",
  TRANSACTION: "/transactions",
  ACC: "/create-account",
  ACC_TYPE: "/create-account/:id",
  MORE: "/more",
  NOTIFI: "/notifications",
  EMPLOYEE: "/employee-mgt",
  INVITE_SIGNATORY: "/signatory-invites",
  ACC_STATEMENT: "/account-statement",
  PERSONAL_ACC: "/personal-account/step-1",
  PERSONAL_ID: "/personal-account/step-2",
  BVN: "/bvn-verification",
  VERIFY_ID: "/personal-account/id-verification",
  INTER: "/personal-account/inter-pass-verification/step-1",
  DRIVE: "/personal-account/drive-lic-verification/step-1",
  NIN: "/personal-account/nin-verification/step-1",
  VOTE: "/personal-account/voter-verification/step-1",
  INFO: "/account/info",
  TRANSFER: "/account/transfer",
  DEPOSIT: "/account/deposit",
  CORP: "/create-business/:id",
  CAC: "/create-business/:id/cac-verification",
  FRONT: "/personal-account/:id-verification/step-2",
  BACK: "/personal-account/:id-verification/step-3",
  REFERRAL: "/referrals",
};
